import { Text } from '../../../../../../../shared/components/Text';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const orderIdFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'order_id',
    headerName: <Text tId={'ORDER_ID'} />,
    renderCell: (rowData: TransactionsListRowProps) => (
      <div className="shorted-cell simple-select overflow-text-ellipsis">
        <div style={{ minWidth: '120px' }}>{rowData.row.orderId}</div>
      </div>
    ),
  };
};
